import { Injectable } from '@angular/core';
import { LoggerService } from '@wdpr/ra-angular-logger';

/**
 * Based on code from this file
 * wdpr-ui-angular-mapplication/src/map/mapplication-helpers.factory.js
 */
@Injectable({
    providedIn: 'root'
})
export class MapHelpers {

    private CLASS_NAME = '[FINDER_MAP] - ';

    constructor(private logger: LoggerService) { }

    /**
     * @name        obtainEffectiveMapId
     * @description Find the name of a map on the page. Used if there is more than one map on the page
     * @param       defaults Defaults for the map
     * @param       mapId? Unique name of the map if there is more than one
     * @returns     string
     */
    public obtainEffectiveMapId(defaults, mapId?) {
        // If mapId is passed in just return it
        if (mapId) {
            return mapId;
        }

        // If nothing is defined in our defaults then just return the default name
        const objectKeys = Object.keys(defaults);
        if (objectKeys.length === 0) {
            return 'main';
        }

        // Look through the keys and return the map name
        const id = objectKeys.find(key =>
            // Find the non inherited property
            defaults.hasOwnProperty(key)
        );

        // By this point we should have an ID. If we don't log the error
        if (!id) {
            this.logger.error(`${this.CLASS_NAME} There is more than one map on the DOM.
            You must provide the map ID`);
        }

        return id;
    }
}
